import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetStatsChat, GetCoupon, GetCouponOne, delCoupon, getCouponFilter} from '../../actions/index';

class Coupons extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.addCoupon = this.addCoupon.bind(this);
        this.renderCoupon = this.renderCoupon.bind(this);
        this.editCoupon = this.editCoupon.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.delCoupon = this.delCoupon.bind(this);
        this.filterInput = this.filterInput.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        let id_package = localStorage.getItem('id_package');
        this.props.GetStatsChat(token);
        this.props.GetCoupon(token, id_package);
    }
    addCoupon(){
        this.context.router.push('/subscription/coupons/add/');
    }
    editCoupon(id){
        this.context.router.push('/subscription/coupons/edit/'+id+'/');
    }
    delCouponOpenModal(id){
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelCoupon').modal('show');
        $('#DelCoupon').on('shown.bs.modal', function () {
            that.props.GetCouponOne(token, id);
        });
    }
    delCoupon(){
        let token = localStorage.getItem('id_token_admin');
        this.props.delCoupon(token, this.props.subscription.coupon_one.id).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                $('input[name="word"]').val('')
                this.props.GetCoupon(token);
            }
        });
    }
    closeModal(){
        $('#DelCoupon').modal('hide');
        this.props.subscription.coupon_one = {};
    }
    renderCoupon(){
        return this.props.subscription.coupon.results.map((item, i)=>{
            return (
                <div className="white-block common-list six clearfix" key={item.id}>
                    <p>{i+1}</p>
                    <p className="common-item-with-tag">
                        <span onClick={this.editCoupon.bind(this, item.id)}>{item.coupon_code}</span>
                    </p>
                    <p>{item.discount} %</p>
                    <p>{item.usages_count} / {item.max_usages}</p>
                    <p>{item.expiration_date}</p>
                    <p className="pull-right">
                        <button type="button" onClick={this.editCoupon.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true"></span>
                        </button>
                        <button type="button" onClick={this.delCouponOpenModal.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-trash"></span>
                        </button>
                    </p>
                </div>
            )
        })
    }
    filterInput(e){
        let token = localStorage.getItem('id_token_admin');
        let data = {
            code: $('input[name="word"]').val()
        }

        this.props.getCouponFilter(token, data);
    }
    render() {
        // {this.props.user.user_all.results && this.props.user.user_all.results.length > 0 ? this.renderTable() : <p className="noResults">No items result</p>}
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-title clearfix">
                    <div className="pull-left">
                        <p className="dashboard-title">Coupons</p>
                        <p className="dashboard-text">Subscription</p>
                    </div>
                    <button onClick={this.addCoupon} type="button" className="pull-right btn btn-primary">
                        <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                        Add coupon
                    </button>
                </div>
                <div>
                    <div className="col-md-12">
                        <div className="white-block">
                            <div className="col-md-4 input-group search_block">
                                <span className="input-group-addon glyphicon glyphicon-search"></span>
                                <input type="text" name="word" className="form-control" placeholder="Search" aria-describedby="Search" onChange={this.filterInput}/>
                            </div>
                        </div>
                    </div>
                    {this.props.subscription.coupon.results && this.props.subscription.coupon.results.length > 0 ?
                        <div>
                            <div className="col-md-12">
                                <div className="common-list six clearfix">
                                    <p>#</p>
                                    <p>Coupon code</p>
                                    <p>Discount percentage</p>
                                    <p>Number of learners</p>
                                    <p>Expiry date</p>
                                    <p>Option</p>
                                </div>
                            </div>
                            <div className="col-md-12">
                                {this.renderCoupon()}
                            </div>
                        </div>
                        :
                        <div className={this.props.subscription.coupon.results && this.props.subscription.coupon.results.length < 0 || $.isEmptyObject(this.props.subscription.coupon) ? "for_preloader" : 'for_preloader dn'}>
                            <div className="preloader-wrapper big active">
                                <div className="spinner-layer spinner-blue-only">
                                    <div className="circle-clipper left">
                                        <div className="circle" />
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle" />
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.subscription.coupon.results && this.props.subscription.coupon.results.length === 0 && <p className="noResults">No items result</p>}
                    <div className="modal fade" id="DelCoupon" tabIndex="-1" role="dialog" aria-labelledby="DelCouponLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelCoupon" />
                                    <p>Do you really want to delete coupon {this.props.subscription.coupon_one ? <span>{this.props.subscription.coupon_one.coupon_code}</span> : ""}?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delCoupon} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>


        );
    }
}


function  mapStateToProps(state) {
    return{
        subscription: state.subscription,
        chat: state.chat


    }
}
export default connect(mapStateToProps, {GetStatsChat, GetCoupon, GetCouponOne, delCoupon, getCouponFilter})(Coupons);



// WEBPACK FOOTER //
// ./src/components/subscription/coupons.js